<template>
  <layout>
    <page-header>
      <template slot="header">
        <h4 class="order-0">
          {{ $t('reviews.company_list_title') }}
        </h4>
        <button
          v-if="isFiltered"
          type="button"
          class="btn btn-link"
          @click.prevent="resetFilters"
        >
          {{ $t('general.reset_filters') }}
        </button>
      </template>
    </page-header>
    <div class="content">
      <admin-table v-if="currentDivision" ref="table" v-bind="tableProps">
        <template slot="company_name" slot-scope="{ item }">
          <span
            ><a
              class="btn btn-link"
              href="#"
              @click.prevent="filterCompany(item)"
              >{{ item.company_name }}</a
            ></span
          >
        </template>
        <template slot="driver_name" slot-scope="{ item }">
          <span>
            <a
              class="btn btn-link"
              href="#"
              @click.prevent="filterDriver(item)"
              >{{ item.driver_name }}</a
            ></span
          >
        </template>
        <template slot="name" slot-scope="{ item }">
          <img
            v-if="item.photo && item.photo.url"
            :src="item.photo.url"
            class="w-16 max-w-full mr-2"
          />
          <div>{{ item.name }}</div>
          <div class="wrap_rating_star">
            <rating-stars :value="item.punctual" :length="5" />
            <rating-stars :value="item.comfort" :length="5" />
            <rating-stars :value="item.clean" :length="5" />
            <span>
              ({{ $t('reviews.reviews_average') }}: {{ item.average }})
            </span>
          </div>
        </template>
        <template slot="booking_id" slot-scope="{ item }">
          <span>{{ $t('reviews.booking_id_place') }}{{ item.booking_id }}</span>
        </template>
        <template slot="text" slot-scope="{ item }">
          <span>{{ item.text }}</span>
        </template>
      </admin-table>
    </div>
    <reply-modal
      v-if="forReply"
      :review="forReply"
      @close="forReply = null"
    ></reply-modal>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import ReviewsApi from './Api'
import RatingStars from '../components/RatingStars'
import ReplyModal from './ReplyModal'

const resourceBase = 'reviews'

export default {
  name: 'Reviews',

  components: {
    AdminTable,
    RatingStars,
    ReplyModal,
  },

  data() {
    return {
      ratings: [1, 2, 3, 4, 5],
      value: 0,
      forReply: null,
      filters: {
        company: null,
        driver: null,
      },
    }
  },

  computed: {
    columns() {
      let columns = [
        {
          key: 'id',
          label: this.$t('general.id'),
          sortable: true,
        },
      ]

      if (this.$allows('administer')) {
        columns.push({
          key: 'company_name',
          label: this.$t('reviews.column_company'),
          sortable: false,
        })
      }
      if (!this.$route.params.id) {
        columns.push({
          key: 'driver_name',
          label: this.$t('reviews.column_driver'),
          sortable: false,
        })
      }
      return [
        ...columns,
        {
          key: 'name',
          label: this.$t('reviews.column_review_rating'),
          sortable: true,
        },
        {
          key: 'booking_id',
          label: this.$t('reviews.column_booking_name'),
          sortable: this.$allows('administer'),
        },
        {
          key: 'user_name',
          label: this.$t('reviews.column_user_name'),
          sortable: true,
        },
        {
          key: 'text',
          label: this.$t('reviews.column_comment'),
        },
        {
          key: 'created_at',
          label: this.$t('reviews.column_created'),
          component: 'value-date',
          sortable: true,
        },
      ]
    },

    tableProps() {
      return {
        base: resourceBase,
        apiBuilder: this.apiBuilder,
        sortBy: 'created_at',
        sortDesc: true,
        perPage: 9,
        columns: this.columns,

        rowActions: item => {
          let actions = []

          if (this.$allows('administer')) {
            actions.push('edit')
            actions.push('delete')
          } else {
            actions.push({
              label: this.$t('reviews.reply'),
              handler: () => {
                this.showReplyModal(item)
              },
              variant: 'primary',
            })
          }
          return actions
        },

        // define custom bulk actions
        bulkActions() {
          let actions = []
          if (this.$allows('administer')) {
            actions.push('delete')
          }
          return actions
        },
      }
    },

    isFiltered() {
      return !!(this.filters.company || this.filters.driver)
    },
  },

  watch: {
    currentDivision() {
      this.$refs.table && this.$refs.table.reset()
    },
  },

  methods: {
    showReplyModal(item) {
      this.forReply = item
    },

    filterCompany(item) {
      this.filters.company = item.company_id
      this.filters.driver = null
      this.$refs.table.reset()
    },

    filterDriver(item) {
      this.filters.driver = item.driver_id
      this.filters.company = null
      this.$refs.table.reset()
    },

    apiBuilder() {
      const api = new ReviewsApi()

      if (this.$route.params.id || this.filters.driver) {
        api.setParameter(
          'driver_id',
          this.$route.params.id || this.filters.driver,
        )
      }
      if (this.filters.company) {
        api.setParameter('company_id', this.filters.company)
      }
      return api
    },

    resetFilters() {
      this.filters.driver = null
      this.filters.company = null
      this.$refs.table.reset()
    },
  },
}
</script>
